export default __webpack_public_path__ + "8edbcb8d35c2d60c3fe2fbb7aa61f6c9.png";